// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__32F9L","author":"Table_author__1JLID","authorImage":"Table_authorImage__14sS1","unreadRow":"Table_unreadRow__2c4Dc"};